import {
  HIS_ADMIN,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_SUPER_ADMIN,
  PathModule,
} from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const ManagementRouter = {
  path: PathModule.MANAGEMENT,
  auth: ["HIS_ADMIN"],
  exact: true,
  children: [
    {
      path: "department",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Organizations/Department/DepartmentIndex"),
      }),
    },
    {
      path: "country",
      // auth: ["HIS_ADMIN"],
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/Country/CountryIndex"),
      }),
    },
    {
      path: "administrative-unit",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./Category/AdministrativeUnit/AdministrativeUnitIndex"),
      }),
    },

    {
      path: "health-care-room",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./Organizations/HealthCareRoom/HealthCareRoomIndex"),
      }),
    },

    {
      path: "hospital-bed",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./HospitalBed/HospitalBedIndex"),
      }),
    },

    {
      path: "service-type",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageService/ServiceType/ServiceTypeIndex"),
      }),
    },
    {
      path: "service-group",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageService/ServiceGroup/ServiceGroupIndex"),
      }),
    },
    {
      path: "health-care-service",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./ManageService/HealthCareService/HealthCareServiceIndex"),
      }),
    },
    {
      path: "service-request-set",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageService/ServiceRequestSet/SRSetIndex"),
      }),
    },
    {
      path: "customer-source",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Promotion/CustomerSource/CustomerSourceIndex"),
      }),
    },
    {
      path: "customer-source-group",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./Promotion/CustomerSourceGroup/CustomerSourceGroupIndex"),
      }),
    },
    {
      path: "medical-equipment-type",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./MedicalEquipmentType/MedicalEquipmentTypeIndex"),
      }),
    },

    {
      path: "medical-equipment",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./MedicalEquipment/MedicalEquipmentIndex"),
      }),
    },
    {
      path: "ethnics",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/Ethnics/EthnicsIndex"),
      }),
    },
    {
      path: "Vat",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/Vat/VatIndex"),
      }),
    },
    {
      path: "promotion-program",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./Category/PromotionProgram/PromotionProgramIndex"),
      }),
    },
    {
      path: "salary-period",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/SalaryPeriod/SalaryPeriodIndex"),
      }),
    },
    {
      path: "employee-status",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/EmployeeStatus/EmployeeStatusIndex"),
      }),
    },
    {
      path: "staff-group",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/StaffGroup/StaffGroupIndex"),
      }),
    },
    {
      path: "emr-organization",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Organizations/Organization/OrganizationIndex"),
      }),
    },
    {
      path: "position",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/Position/PositionIndex"),
      }),
    },
    {
      path: "activity-log",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ActivityLog/ActivityLogIndex"),
      }),
    },
    {
      path: "module",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./SystemManagement/Module/ModuleIndex"),
      }),
    },
    {
      path: "role",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./SystemManagement/Role/RoleIndex"),
      }),
    },
    {
      path: "permission",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./SystemManagement/Permission/PermissionIndex"),
      }),
    },
    {
      path: "systemConfig",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./SystemManagement/SystemConfig/SystemConfigIndex"),
      }),
    },
    //

    {
      path: "encounter-type",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./EncounterType/EncounterTypeIndex"),
      }),
    },
    {
      path: "interest-rate-period",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./InterestRatePeriod/InterestRatePeriodIndex"),
      }),
    },
    {
      path: "services",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageService/ManageServiceIndex"),
      }),
    },

    {
      path: "person-attribute-type",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./PersonAttributeType/PersonAttributeTypeIndex"),
      }),
    },
    {
      path: "concept",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageConcept/ManageConceptIndex"),
      }),
    },
    {
      path: "alert",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageAlert/ManageAlertIndex"),
      }),
    },
    {
      path: "medical-record",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./MedicalRecord/MedicalRecordIndex"),
      }),
    },

    {
      path: "user-account",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./UserAccount/UserAccountIndex"),
      }),
    },

    {
      path: "insurance-payment-type-rate",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./InsurancePaymentTypeRate/IPTRIndex"),
      }),
    },

    {
      path: "medical-equipment",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./MedicalEquipment/MedicalEquipmentIndex"),
      }),
    },
    {
      path: "shift-works",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ShiftWork/ShiftWorksIndex"),
      }),
    },
    {
      path: "category",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Category/CategoryIndex"),
      }),
    },
    {
      path: "organizations",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Organizations/OrganizationsIndex"),
      }),
    },
    {
      path: "drug-and-medical-supply",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./DrugAndMedicalSupplies/DrugAndMedicalSupplyIndex"),
      }),
    },
    {
      path: "funding-source",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./FundingSource/FundingSourceIndex"),
      }),
    },
    {
      path: "system-management",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./SystemManagement/SystemManagementIndex"),
      }),
    },
    {
      path: "promotion",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Promotion/PromotionIndex"),
      }),
    },
    {
      path: "exam-template",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ExamTemplate/ExamTemplateIndex"),
      }),
    },
    {
      path: "supplements",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Supplements/SupplementsIndex"),
      }),
    },
    {
      path: "medical-record-summary-type",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "./MedicalRecord/MedicalRecordSummaryType/MedicalRecordSummaryTypeIndex"
          ),
      }),
    },
    {
      path: "patient-group",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./PatientGroupType/PatientGroupTypeIndex"),
      }),
    },
    {
      path: "patient-type",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./PatientType/PatientTypeIndex"),
      }),
    },
    {
      path: "patient-rank",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./PatientRank/PatientRankIndex"),
      }),
    },
    {
      path: "payment-method",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./PaymentMethod/PaymentMethodIndex"),
      }),
    },
    {
      path: "patient-type-service/:type",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./ManageConcept/PatientTypeService/PatientTypeServiceIndex"),
      }),
    },
    {
      path: "client-card",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ClientCard/ClientCardIndex"),
      }),
    },
    {
      path: "drug",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./DrugAndMedicalSupplies/Drug/DrugIndex"),
      }),
    },
    {
      path: "medical-supply",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./DrugAndMedicalSupplies/MedicalSupply/MedicalSupplyIndex"),
      }),
    },
    {
      path: "quantity-unit",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./DrugAndMedicalSupplies/QuantityUnit/QuantityUnitIndex"),
      }),
    },
    {
      path: "inventory-reports-by-drug",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./DrugAndMedicalSupplies/DrugStore/DrugStoreIndex"),
      }),
    },
    {
      path: "abstract-product",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "./DrugAndMedicalSupplies/AbstractProduct/AbstractProductIndex"
          ),
      }),
    },
    {
      path: "service-role",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ManageService/ServiceRole/ServiceRoleIndex"),
      }),
    },
    {
      path: "global-propoties",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./ExamTemplate/GlobalPropoties/GlobalPropotiesIndex"),
      }),
    },
    {
      path: "client-award-type",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ClientAwardType/ClientAwardTypeIndex"),
      }),
    },
    {
      path: "revenue-expenditure",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("./ManageConcept/RevenueExpenditure/RevenueExpenditureIndex"),
      }),
    },
    {
      path: "report-by-payment-method",
      auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportPayment/ReportPaymentIndex"),
      }),
    },
    {
      path: "staff-list",
      auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/Staff/StaffList/StaffListIndex"),
      }),
    },
    {
      path: "staff-info",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/Staff/StaffList/StaffInfo"),
      }),
    },
    {
      path: "visit-type",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./VisitType/VisitTypeIndex"),
      }),
    },
    {
      path: "async-management",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./AsyncManagement/AsyncManagementIndex"),
      }),
    },
    {
      path: "permission-staff",
      exact: true,
      component: EgretLoadable({
        loader: () => import("../Staff/PermissionStaff/PermissionStaffIndex"),
      }),
    },

    {
      path: "menu",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Menu/MenuIndex"),
      }),
    },
    {
      path: "embedded-iframe",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/EmbeddedIFrame/EmbeddedIFrameIndex"),
      }),
    },
  ],
};

export default ManagementRouter;
